<main
  class="message-field show rounded-lg p-[12px]"
  [class.filled]="variant === 'filled'"
  [class.outlined]="variant === 'outlined'"
  [class.text-gray-50]="variant === 'filled'"
  [class.bg-warning]="variant === 'filled' && colorValue === 'warning'"
  [class.bg-primary]="variant === 'filled' && colorValue === 'primary'"
  [class.bg-error]="variant === 'filled' && colorValue === 'danger'"
  [class.bg-success]="variant === 'filled' && colorValue === 'success'"
  [class.bg-gray-700]="variant === 'filled' && colorValue === 'info'"
  [class.shadow]="variant === 'outlined'"
  [class.ml-[10px]]="variant === 'outlined'"
  [class.border-b-[3px]]="variant === 'outlined'"
  [class.border-solid]="variant === 'outlined'"
  [class.border-warning]="variant === 'outlined' && colorValue === 'warning'"
  [class.border-primary]="variant === 'outlined' && colorValue === 'primary'"
  [class.border-error]="variant === 'outlined' && colorValue === 'danger'"
  [class.border-success]="variant === 'outlined' && colorValue === 'success'"
  [class.border-gray-700]="variant === 'outlined' && colorValue === 'info'"
>
  <p class="text-[12px]">
    {{ labelValue }}
  </p>
</main>
